// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modatHeader__wrapper","close":"modatHeader__close"};